<template>
  <div>
    <div>
      <v-img src="@/assets/images/knowlenge-empty.png" />
    </div>
    <div class="text-center">
      Ninguna competencia asignada aún.
    </div>
  </div>
</template>